import type { CartOutputDto, PaymentProfileDto } from "@sticker-giant/sg-frontend-common";
import { PaymentMethodType } from "@sticker-giant/sg-frontend-common";
import type { CreditCardType } from "@/constants/CreditCardType";
import { NEW_CARD } from "@/lib/payment/savedCards";

export interface PaymentSelection {
  paymentMethod: PaymentMethodType;
  paymentToken: string | undefined;
  savedCard: PaymentProfileDto | undefined;
}

// The payment choice a successful Payment submit commits to the store.
// `paymentToken` is the opaque Accept.js nonce and `maskedCCNumber` is already masked — no raw card data.
export interface ConfirmedPayment {
  paymentMethod: PaymentMethodType;
  selectedSavedCardId: string | undefined;
  paymentToken: string | undefined;
  creditCardType: CreditCardType | undefined;
  maskedCCNumber: string | undefined;
  saveCard: boolean;
}

// Keeps only the fields that apply to what the customer is paying with.
export function toConfirmedPayment(
  draft: ConfirmedPayment,
  displayedSavedCard: PaymentProfileDto | undefined,
): ConfirmedPayment {
  const noCard = {
    selectedSavedCardId: undefined,
    paymentToken: undefined,
    creditCardType: undefined,
    maskedCCNumber: undefined,
    saveCard: false,
  };
  if (draft.paymentMethod !== PaymentMethodType.CREDIT_CARD) return { paymentMethod: draft.paymentMethod, ...noCard };
  if (displayedSavedCard) {
    return { ...noCard, paymentMethod: draft.paymentMethod, selectedSavedCardId: displayedSavedCard.paymentProfileId };
  }
  const { paymentMethod, paymentToken, creditCardType, maskedCCNumber, saveCard } = draft;
  return { paymentMethod, selectedSavedCardId: NEW_CARD, paymentToken, creditCardType, maskedCCNumber, saveCard };
}

export function isPaymentComplete(
  cart: CartOutputDto,
  { paymentToken, paymentMethod, savedCard }: PaymentSelection,
): boolean {
  if (cart.shippingInfo.blindShip && !cart.billingInfo.billingAddress) return false;
  if (paymentMethod === PaymentMethodType.CREDIT_CARD) {
    return Boolean((paymentToken || savedCard) && cart.billingInfo.billingAddress);
  }
  return true;
}
